import { inject } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
    Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { filter, map, take } from "rxjs/operators";
import { UserAuthService } from "src/app/core/services/auth/user-auth.service";

export const isAuthenticatedAndAdminGuard = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
): Observable<boolean | UrlTree> => {
    const userService = inject(UserAuthService);
    const router = inject(Router);

    return userService.userPopulated$.pipe(
        filter((populated) => populated),
        take(1),
        map(() => {
            const user = userService.user();
            if (user && user.isActive) return true;
            return router.createUrlTree(["/login"], {
                queryParams: { unauthorized: true },
            });
        }),
    );
};

export const isAuthenticated = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
): Observable<boolean | UrlTree> => {
    const userService = inject(UserAuthService);
    const router = inject(Router);

    return userService.userPopulated$.pipe(
        filter((populated) => populated),
        take(1),
        map(() => {
            const user = userService.user();
            return user ? true : router.parseUrl("/auth/login");
        }),
    );
};
